import {
  IModifyParamsToSend,
  IParamsToSend
} from '@base/@types/providers/Kpi/StorageProvider'

function convertDateFormat(dateStr: string): string {
  const [day, month, year] = dateStr.split('/')
  return `${year}-${month}-${day}`
}
export const paramsToSendMapping = ({
  name,
  value,
  compareName,
  fieldName,
  paramsToSend
}: IModifyParamsToSend) => {
  const paramsToSendFormatted: IParamsToSend = { ...paramsToSend }

  if (name === 'closingBase') {
    paramsToSendFormatted.periodo = convertDateFormat(value.value)
    return paramsToSendFormatted
  }
  if (name === 'vendaMediaIds') {
    paramsToSendFormatted.periodoVendaMedia = Number(value)

    return paramsToSendFormatted
  }

  if (name === 'CMVouEstoque') {
    paramsToSendFormatted.CMVouEstoque =
      value === 'sim' ? true : value === 'não' ? false : null

    return paramsToSendFormatted
  }

  if (name === 'curvaAbcIds' || name === 'curvaAbcSelectIds') {
    paramsToSendFormatted.curvaABC = {
      agrupar:
        typeof value === 'boolean'
          ? value
          : paramsToSendFormatted.curvaABC.agrupar,
      descricoes:
        typeof value === 'object'
          ? value.map((item: { value: any }) => item.value)
          : paramsToSend.curvaABC.descricoes
    }

    return paramsToSendFormatted
  }

  if (name === compareName) {
    paramsToSendFormatted[fieldName] = {
      agrupar:
        typeof value === 'boolean'
          ? value
          : paramsToSendFormatted[fieldName]?.agrupar,
      ids:
        typeof value === 'object'
          ? value.map((item: { value: any }) => item.value)
          : paramsToSend[fieldName]?.ids
    }
  }

  return paramsToSendFormatted
}
